import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { palette } from "../../../assets/styles/Palette";
import AtomPersonaLoader from "../../Global/components/atoms/AtomPersonaLoader";
import { Button } from "../../../assets/styles/ButtonStyle";
import PopupWrap from "../../../assets/styles/Popup";
import {
  ContentsWrap,
  MainContent,
  TabContent5,
  TabContent5Item,
  DropzoneStyles,
} from "../../../assets/styles/BusinessAnalysisStyle";
import {
  H3,
} from "../../../assets/styles/Typography";
import "react-dropzone-uploader/dist/styles.css";
import { useDynamicViewport } from "../../../assets/DynamicViewport";
import MoleculeFileUpload from "../components/molecules/MoleculeFileUpload";
import MoleculeAnalysisCard from "../components/molecules/MoleculeAnalysisCard";
import MoleculeCreateDisplayHeader from "../components/molecules/MoleculeCreateDisplayHeader";

import {
  FormBox,
  CustomInput,
} from "../../../assets/styles/InputStyle";

import {
  IS_LOGGED_IN,
  AUTODISPLAY_SELECTED_DEVICE,
  AUTODISPLAY_DESIGN_GENERATOR,
  CUSTOMER_ID
} from "../../AtomStates";
import { useAtom } from "jotai";
import {
  uploadProjectImages,
  createInfoBoardContentOnServer,
  updateInfoBoardContentOnServer,
  getUserMemberType,
} from "../../../utils/indexedDB";

const PageCreateInfoContentImage = () => {
  const navigate = useNavigate();

  const [linkUrl, setLinkUrl] = useState("");
  const [isLoggedIn] = useAtom(IS_LOGGED_IN);
  const [selectedDevice] = useAtom(AUTODISPLAY_SELECTED_DEVICE);
  // UI 상태 관리
  const [showPopupError, setShowPopupError] = useState(false);
  const [activeTab, setActiveTab] = useState(1);
  const [completedSteps, setCompletedSteps] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showPopupFileSize, setShowPopupFileSize] = useState(false);
  const [toolSteps, setToolSteps] = useState(0);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [fileNames, setFileNames] = useState([]);
  const [showToast, setShowToast] = useState(false);
  const [customerId] = useAtom(CUSTOMER_ID);
  const [dataAnalysisTitle, setDataAnalysisTitle] = useState("");
  const [previewImageUrl, setPreviewImageUrl] = useState(null);

  useDynamicViewport("width=1280");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const checkMemberType = async () => {
      const accessToken = sessionStorage.getItem("accessToken");
      const userMemberType = await getUserMemberType(accessToken);
      const lastUrl = sessionStorage.getItem("lastUrl");

      if (
        (lastUrl === "/CreateApiContent" || lastUrl === "/ApiDashBoard") &&
        userMemberType.member_type === 99
      ) {
        navigate("/Admin");
      }

      if (userMemberType.member_type === 11) {
        navigate("/DashBoard");
      } else if (userMemberType.member_type === 12) {
        navigate("/CustomerManage");
      } else if (userMemberType.member_type === 21) {
        navigate("/ApiDashBoard");
      } else if (userMemberType.member_type === 22) {
        navigate("/CustomerManage");
      }
    };

    checkMemberType();
  }, []);

  useEffect(() => {
    if (showToast) {
      document.body.style.overflow = "hidden";
      document.body.style.paddingRight = "15px";
    } else {
      document.body.style.overflow = "auto";
      document.body.style.paddingRight = "0";
    }

    return () => {
      document.body.style.overflow = "auto";
      document.body.style.paddingRight = "0";
    };
  }, [showToast]);

  const handleSubmitConcept = async () => {
    // 이미 완료된 경우 2단계로 이동
    if (completedSteps.includes(1)) {
      setActiveTab(2);
      return;
    }
    
    setIsLoading(true);
    setToolSteps(2);
    
    // 로딩 화면을 보여주기 위해 2단계로 이동
    setCompletedSteps([1]);
    setActiveTab(2);

    try {
      // 1단계: 콘텐츠 생성
      const createViewId = await createInfoBoardContentOnServer(isLoggedIn);
      console.log("Created content ID:", createViewId);

      // 2단계: 이미지 업로드
      const uploadResult = await uploadProjectImages({
        id: createViewId,
        files: uploadedFiles,
      });
      
      console.log("Upload result:", uploadResult);

      // 3단계: 콘텐츠 업데이트 (이미지 정보 저장)
      const now = new Date();
      const contentData = {
        contentsType: "image",
        dataAnalysis: {
          title: dataAnalysisTitle
        },
        createDate: now.toLocaleString("ko-KR", {
          timeZone: "Asia/Seoul",
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        }),
        createTimestamp: now.getTime(),
      };

      if (customerId !== "") {
        contentData.customer = customerId;
      }

      await updateInfoBoardContentOnServer(createViewId, contentData);
      
      setToolSteps(3);
      setCompletedSteps([1, 2]);
      setIsLoading(false);
      
      // 완료됨을 표시하고 페이지 업데이트
      
    } catch (error) {
      console.error("콘텐츠 생성/업로드 중 오류 발생:", error);
      setShowPopupError(true);
      setIsLoading(false);
    }
  };

  const handleSubmitPurpose = async () => {
    // 이미지 콘텐츠는 이 함수 사용 안 함
    return;
  };

  const handleChangeStatus = ({ meta, file, remove }, status) => {
    const maxSize = 20 * 1024 * 1024; // 20MB
    if (file.size > maxSize && status !== "removed") {
      setShowPopupFileSize(true);
      remove();
      return;
    }

    if (status === "done" || status === "preparing" || status === "uploading") {
      setUploadedFiles((prev) => {
        if (!prev.find((f) => f.name === file.name)) {
          setFileNames((prev) => [...prev, file.name]);
          // 이미지 미리보기를 위한 URL 생성
          const imageUrl = URL.createObjectURL(file);
          setPreviewImageUrl(imageUrl);
          return [...prev, file];
        }
        return prev;
      });
    } else if (status === "removed") {
      setUploadedFiles((prev) => prev.filter((f) => f.name !== file.name));
      setFileNames((prev) => prev.filter((name) => name !== file.name));
      // 이미지 URL 정리
      if (previewImageUrl) {
        URL.revokeObjectURL(previewImageUrl);
        setPreviewImageUrl(null);
      }
    }

    const size = file.size;
    const sizeStr =
      size > 1024 * 1024
        ? `${(size / (1024 * 1024)).toFixed(1)}MB`
        : `${(size / 1024).toFixed(1)}KB`;

    setTimeout(() => {
      const containers = document.querySelectorAll(".dzu-previewContainer");
      containers.forEach((container) => {
        if (!container.dataset.filename) {
          container.dataset.filename = file.name;
          container.dataset.size = sizeStr;

          if (file.type.startsWith("image/")) {
            if (!container.querySelector(".dzu-previewFileName")) {
              const nameSpan = document.createElement("span");
              nameSpan.className = "dzu-previewFileName";
              nameSpan.textContent = `${file.name}, ${sizeStr}`;

              if (container.firstChild) {
                container.insertBefore(nameSpan, container.firstChild);
              } else {
                container.appendChild(nameSpan);
              }
            }
          }
        }
      });
    }, 0);
  };

  const handleDisplayConversion = async () => {
    // 이미지 콘텐츠는 즉시 완료됨
    return;
  };

  const handleTemplatePreview = (template) => {
    // 이미지 미리보기 기능
    if (previewImageUrl) {
      // sessionStorage에 미리보기 데이터 저장
      sessionStorage.setItem('imagePreviewData', JSON.stringify({
        imageUrl: previewImageUrl,
        title: dataAnalysisTitle,
        fileName: fileNames[0]
      }));
      
      // 새 창으로 미리보기 열기
      const previewUrl = `http://${window.location.host}/AutodisplayViewLinkLotation/preview/image`;
      window.open(previewUrl, '_blank', 'width=1920,height=1080');
    }
  };

// 업로드된 파일명 영역에 인라인 미리보기 버튼 삽입
  useEffect(() => {
    const containers = document.querySelectorAll('.dzu-previewContainer');
    containers.forEach((container) => {
      // 정렬을 위해 컨테이너를 플렉스 레이아웃으로 맞춤
      container.style.display = 'flex';
      container.style.alignItems = 'center';
      container.style.justifyContent = 'flex-start';
      container.style.gap = '8px';

      // 이미 버튼이 있다면 중복 생성 방지
      if (container.querySelector('.preview-inline-btn')) return;

      const previewBtn = document.createElement('button');
      previewBtn.type = 'button';
      previewBtn.className = 'preview-inline-btn';
      previewBtn.setAttribute('aria-label', '미리보기');
      
      // 스타일 설정
      Object.assign(previewBtn.style, {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '8px 12px', // 패딩을 조금 조절하여 핏하게 맞춤
        // marginLeft: 'auto', // 이 부분을 제거하거나 조절 (필요 시 파일명과 버튼 사이 간격을 최대로 벌리려면 주석 해제)
        border: 'none',
        borderRadius: '6px',
        background: '#f2f4f7',
        cursor: 'pointer',
        transition: 'background 0.2s ease, transform 0.2s ease',
        height: '32px', // 높이 고정 (선택 사항)
      });

      previewBtn.innerHTML = `
        <svg width="18" height="18" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" style="flex-shrink:0;">
          <path d="M10.4991 4.9375C14.2651 4.9376 17.6532 7.00578 18.712 9.81836C18.8158 10.0941 18.8308 10.4038 18.7374 10.6992C18.0917 12.7392 15.547 15.4374 10.4991 15.4375C5.43073 15.4375 2.93409 12.476 2.27936 10.7217C2.17268 10.4358 2.17158 10.1309 2.25983 9.85352C2.7197 8.40882 3.86624 7.17982 5.3194 6.32129C6.77927 5.4589 8.5994 4.9375 10.4991 4.9375ZM10.4991 6.27051C8.83591 6.27051 7.25005 6.7295 5.99713 7.46973C4.73751 8.21395 3.86349 9.2112 3.53034 10.2578L3.52936 10.2598C4.00367 11.5242 6.02377 14.1045 10.4991 14.1045C15.0269 14.1044 17.0129 11.7269 17.4659 10.2988V10.2979C17.4658 10.2964 17.4657 10.2929 17.4639 10.2881C16.6478 8.12022 13.8568 6.27061 10.4991 6.27051ZM10.4991 7.02148C12.2479 7.02148 13.666 8.43867 13.6661 10.1875C13.6661 11.9364 12.248 13.3545 10.4991 13.3545C8.75034 13.3543 7.33307 11.9363 7.33307 10.1875C7.33316 8.43878 8.75039 7.02166 10.4991 7.02148ZM10.4991 8.35449C9.48677 8.35467 8.66617 9.17516 8.66608 10.1875C8.66608 11.1999 9.48671 12.0213 10.4991 12.0215C11.5116 12.0215 12.3331 11.2 12.3331 10.1875C12.333 9.17505 11.5116 8.35449 10.4991 8.35449Z" fill="#666666" />
        </svg>
        <span style="margin-left:6px;font-size:13px;font-weight:500;color:#666;white-space:nowrap;">미리보기</span>
      `;

      previewBtn.onmouseenter = () => {
        previewBtn.style.background = '#e5e8ec';
      };
      previewBtn.onmouseleave = () => {
        previewBtn.style.background = '#f2f4f7';
      };

      previewBtn.onclick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        handleTemplatePreview();
      };

      // ▼▼▼▼▼ 수정된 핵심 로직 ▼▼▼▼▼
      
      // 1. X 버튼을 감싸고 있는 Status Container를 찾습니다.
      const statusContainer = container.querySelector('.dzu-previewStatusContainer');

      if (statusContainer) {
        // Status Container가 있으면 그 앞에 미리보기 버튼을 넣습니다.
        container.insertBefore(previewBtn, statusContainer);
        
        // (선택사항) 만약 X버튼 그룹을 오른쪽 끝으로 밀고 싶다면:
        // previewBtn.style.marginLeft = 'auto'; 
      } else {
        // 2. 혹시 구조가 달라서 Status Container가 없고 버튼(span)만 있는 경우를 대비
        const removeBtn = container.querySelector('.dzu-previewButton');
        if (removeBtn) {
           container.insertBefore(previewBtn, removeBtn);
        } else {
           // 아무것도 못 찾으면 그냥 맨 뒤에 추가
           container.appendChild(previewBtn);
        }
      }
      // ▲▲▲▲▲ 수정 완료 ▲▲▲▲▲
    });
  }, [fileNames, previewImageUrl]);

  const handleConfirmContent = async () => {
    // 2단계에서 완료됨
    navigate("/InfoContentManageDashBoard");
  };

  useEffect(() => {
    // 새로고침 감지 함수
    const detectRefresh = () => {
      // 현재 URL 확인
      const currentUrl = window.location.href;
      if (currentUrl.toLowerCase().includes("createinfocontentlink")) {
        // 세션 스토리지에서 마지막 URL 가져오기
        const lastUrl = sessionStorage.getItem("lastUrl");

        // 마지막 URL이 현재 URL과 같으면 새로고침
        if (lastUrl && lastUrl === currentUrl) {
          // if (customerId !== "") {
          //   navigate("/EduboardManage");
          // } else {
            navigate("/InfoContentManageDashBoard");
          // }
          return true;
        }

        // 현재 URL 저장
        sessionStorage.setItem("lastUrl", currentUrl);
      }

      return false;
    };

    // F5 키 또는 Ctrl+R 감지
    const handleKeyDown = (event) => {
      if (
        (event.key === "r" && (event.metaKey || event.ctrlKey)) ||
        event.key === "F5"
      ) {
        // F5 키 코드
        event.preventDefault();

        // if (customerId !== "") {
        //   navigate("/EduboardManage");
        // } else {
          navigate("/InfoContentManageDashBoard");
        // }
      }
    };

    // 함수 실행
    detectRefresh();

    // 이벤트 리스너 등록
    window.addEventListener("keydown", handleKeyDown);

    // 컴포넌트 언마운트 시 이벤트 리스너 제거
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [navigate]);

  const handleGoBack = async () => {
    navigate("/InfoContentManageDashBoard");
  };

  return (
    <>
      <DropzoneStyles />
      <ContentsWrap>
        {/* <OrganismIncNavigation /> */}
        {/* <MoleculeHeader /> */}
        <MoleculeCreateDisplayHeader
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          completedSteps={completedSteps}
          isLoading={isLoading}
          onPreview={handleTemplatePreview}
          onSubmitConcept={handleSubmitConcept}
          onSubmitReport={handleSubmitPurpose}
          onDisplayConversion={handleDisplayConversion}
          hasContentDraft={false}
          onConfirmContent={handleConfirmContent}
          // 1단계에서 파일 업로드와 타이틀 입력이 모두 있어야 진행
          canProceedFromStep1={
            activeTab === 1
              ? fileNames && fileNames.length > 0 && dataAnalysisTitle.trim().length > 0
              : true
          }
          // 2단계에서 모든 필수 항목이 선택되었는지 확인
          canProceedFromStep2={
            false
          }
          canProceedFromStep3={
            false
          }
          customSteps={[
            { number: 1, label: "이미지 업로드", activeTab: 1 },
            { number: 2, label: "화면 실행", activeTab: 2, requiredCompletedStep: 1 },
          ]}
        />

        <MainContent Wide1030>
          <DesignAnalysisWrap>
            {activeTab === 1 && (
              <TabContent5>
                <>
                  <div className="content">
                    <TabContent5Item required>
                      <div style={{ height: "20px" }}></div>
                      <H3
                        color="gray800"
                        style={{ textAlign: "left" }}
                      >
                        콘텐츠 생성을 위한 이미지를 업로드해주세요{" "}
                      </H3>
                    </TabContent5Item>
                  </div>

                  <div className="content">
                    <TabContent5Item required>
                      <div className="content" style={{ marginTop: "0px" }}>
                        <MoleculeFileUpload
                          fileNames={fileNames ?? []}
                          handleChangeStatus={handleChangeStatus}
                          toolSteps={toolSteps}
                          type="image"
                          maxFiles={1}
                        />
                      </div>
                    </TabContent5Item>
                  </div>

                  <div className="content" style={{ marginTop: "20px" }}>
                    <ContentOptionsSection>
                      <TabContent5Item>
                        <InputGroup>
                          <Label>타이틀 입력</Label>
                          <FormBox Large>
                            <CustomInput
                              Edit
                              type="text"
                              placeholder="타이틀을 입력하세요"
                              value={dataAnalysisTitle}
                              onChange={(e) => setDataAnalysisTitle(e.target.value)}
                              status="valid"
                              disabled={toolSteps >= 1}
                            />
                          </FormBox>
                        </InputGroup>
                      </TabContent5Item>
                    </ContentOptionsSection>
                  </div>
                </>
              </TabContent5>
            )}

            {activeTab === 2 &&
              (completedSteps.includes(1)) && (
                <TabContent5>
                  {isLoading ? (
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        minHeight: "200px",
                        alignItems: "center",
                      }}
                    >
                      <AtomPersonaLoader message="이미지를 업로드하고 있어요" />
                    </div>
                  ) : (
                    <>
                      <div className="content">
                        <TabContent5Item required>
                          {/* <H3
                            color="gray800"
                            style={{ textAlign: "left", marginBottom: "-20px" }}
                          >
                            이미지 콘텐츠가 정상적으로 등록되었습니다{" "}
                          </H3> */}
                          <DashedLine />
                          <CompletionContainer>
                            <CompletionIcon>
                              <CheckIcon>
                                <svg
                                  width="28"
                                  height="26"
                                  viewBox="0 0 28 26"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M26.7408 1.07458C27.9568 1.9055 28.269 3.56483 27.438 4.78081L13.7714 24.7808C13.3237 25.4359 12.6076 25.8576 11.8176 25.9314C11.0277 26.0052 10.2458 25.7234 9.68463 25.1625L1.34609 16.8292C0.304367 15.7881 0.30384 14.0997 1.34491 13.0579C2.38599 12.0162 4.07443 12.0157 5.11615 13.0568L11.1813 19.1181L23.0346 1.77179C23.8655 0.555813 25.5249 0.243661 26.7408 1.07458Z"
                                    fill="white"
                                  />
                                </svg>
                              </CheckIcon>
                            </CompletionIcon>

                            <CompletionMessage>
                              <H3
                                color="gray800"
                                style={{
                                  marginBottom: "8px",
                                  marginTop: "16px",
                                }}
                              >
                                콘텐츠 등록이 완료되었습니다
                              </H3>
                            </CompletionMessage>
                          </CompletionContainer>

                          <ContentAnalysisSection>
                            <MoleculeAnalysisCard
                              showButton={false}
                              type="image"
                              values={{
                                analysisData: {
                                  title: dataAnalysisTitle
                                },
                                imageTitle: fileNames[0]
                              }}
                            />
                          </ContentAnalysisSection>
                          <DashedLine />
                        </TabContent5Item>
                      </div>

                      <ButtonContainer>
                        <Button
                          Primary
                          Large
                          Fill
                          style={{
                            width: "120px",
                            height: "40px",
                            fontSize: "16px",
                          }}
                          onClick={handleConfirmContent}
                        >
                          확인
                        </Button>
                      </ButtonContainer>
                    </>
                  )}
                </TabContent5>
              )}
          </DesignAnalysisWrap>
        </MainContent>
      </ContentsWrap>

      {showPopupError && (
        <PopupWrap
          Warning
          title="다시 입력해 주세요."
          message="현재 입력하신 정보는 목적을 생성할 수 없습니다."
          buttonType="Outline"
          confirmText="확인"
          isModal={false}
          onConfirm={() => window.location.reload()}
        />
      )}

      {showPopupFileSize && (
        <PopupWrap
          Warning
          title="파일 크기 초과"
          message="파일 크기는 20MB를 초과할 수 없습니다."
          buttonType="Outline"
          confirmText="확인"
          isModal={false}
          onConfirm={() => setShowPopupFileSize(false)}
        />
      )}
    </>
  );
};

export default PageCreateInfoContentImage;

const DesignAnalysisWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 100px;
  margin-top: 60px;
`;

export const CheckCircle = styled.input`
  appearance: none;
  display: block !important;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  cursor: pointer;

  background-image: ${(props) =>
    props.checked
      ? `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'%3E%3Ccircle cx='12' cy='12' r='12' fill='%23226FFF'/%3E%3Cpath d='M6.76562 12.4155L9.9908 15.6365L17.2338 8.36426' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")`
      : `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'%3E%3Ccircle cx='12' cy='12' r='11.5' stroke='%23E0E4EB'/%3E%3C/svg%3E")`};
  transition: background-image 0.3s ease-in-out;

  + label {
    cursor: pointer;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;

    + label {
      cursor: not-allowed;
      opacity: 0.5;
    }
  }
`;

const ContentAnalysisSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin: 24px 0 0px 0;
  width: 100%;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
`;

const CompletionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin: 32px auto;
  text-align: center;
  width: 100%;
`;

const CompletionIcon = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: ${palette.primary};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CheckIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const CompletionMessage = styled.div`
  text-align: center;
  max-width: 400px;
`;

const DashedLine = styled.div`
  width: 100%;
  height: 1px;
  border-top: 2px solid ${palette.gray300};
  margin: 0px;
  margin-top: 32px;
  margin-bottom: 36px;
`;

const ContentOptionsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Label = styled.label`
  color: #666666;
  font-size: 16px;
  font-family: Pretendard;
  font-weight: 700;
  line-height: 1.55;
  text-align: left;
`;

const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  width: 100%;
`;

const PreviewButton = styled.button`
  background: ${palette.gray100};
  color: ${palette.gray700};
  border: none;
  padding: 10px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  flex-shrink: 0;
  min-width: fit-content;
  
  &:hover {
    background: ${palette.gray200};
  }
  
  svg {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
  }
`;